export default __webpack_public_path__ + "static/media/vimeo.bc8058b2.svg";